<template>
  <mdb-navbar-nav>
    <mdb-nav-item  :to="{name: 'Home'}" active icon="home">Home</mdb-nav-item>
    <mdb-dropdown tag="li" class="nav-item" v-if="isStaff">
      <mdb-dropdown-toggle v-if="isStaff" tag="a" navLink color="indigo" slot="toggle" icon="landmark">운영</mdb-dropdown-toggle>
      <mdb-dropdown-menu>
        <mdb-dropdown-item v-if="isAdmin" :to="{name: 'AdminOrgPage'}">기관관리</mdb-dropdown-item>
        <mdb-dropdown-item :to="{name: 'StaffNcsTrainingPage'}">NCS 훈련 지침 관리</mdb-dropdown-item>
        <mdb-dropdown-item :to="{name: 'StaffOpenTrainingPage'}">훈련과정 개설</mdb-dropdown-item>
        <!-- <mdb-dropdown-item :to="{name: 'StaffAgreementPage'}">동의서 관리</mdb-dropdown-item> -->
      </mdb-dropdown-menu>
    </mdb-dropdown>
    <mdb-nav-item v-if="isTeacher" :to="{name: 'TrainingIntro'}" icon="landmark">훈련소개</mdb-nav-item>
    <mdb-dropdown tag="li" class="nav-item">
      <mdb-dropdown-toggle tag="a" navLink color="indigo" slot="toggle" icon="highlighter">평가</mdb-dropdown-toggle>
      <mdb-dropdown-menu>
        <mdb-dropdown-item :to="{name: 'StaffTestSummaryBySubject'}"><mdb-icon icon="highlighter"/> 채점</mdb-dropdown-item>
        <mdb-dropdown-item :to="{name: 'StaffTotalSummary'}"><mdb-icon icon="poll-h" /> 종합 결과</mdb-dropdown-item>
      </mdb-dropdown-menu>
    </mdb-dropdown>
    <!-- <mdb-nav-item :to = "{ name: 'StaffProceedingPage' }" icon="chalkboard-teacher">회의록</mdb-nav-item> -->
    <mdb-dropdown tag="li" class="nav-item">
      <mdb-dropdown-toggle tag="a" navLink color="indigo" slot="toggle" icon="edit">회의록/상담...</mdb-dropdown-toggle>
      <mdb-dropdown-menu>
        <mdb-dropdown-item :to = "{ name: 'StaffProceedingPage' }"><mdb-icon icon="chalkboard-teacher"/> 회의록</mdb-dropdown-item>
        <mdb-dropdown-item :to = "{ name: 'StaffRegularCounselPage' }"><mdb-icon icon="comments"/> 상담</mdb-dropdown-item>
        <mdb-dropdown-item :to = "{ name: 'StaffDailyLogPage' }"><mdb-icon icon="calendar-day"/> 일지</mdb-dropdown-item>
      </mdb-dropdown-menu>
    </mdb-dropdown>
    <mdb-dropdown tag="li" class="nav-item">
      <mdb-dropdown-toggle tag="a" navLink color="indigo" slot="toggle" waves-fixed icon="comments"> 커뮤니티</mdb-dropdown-toggle>
      <mdb-dropdown-menu>
        <mdb-dropdown-item :to="{name: 'StaffNotificationPage'}" ><mdb-icon icon="bell"/> 공지사항</mdb-dropdown-item>
        <mdb-dropdown-item :to="{ name: 'StaffBoardPage'}" ><mdb-icon icon="clipboard"/> 게시판</mdb-dropdown-item>
      </mdb-dropdown-menu>
    </mdb-dropdown>
    <mdb-nav-item v-if="isStaff" :to="{name: 'StaffTeacherManagePage'}" icon="users"> 강사관리</mdb-nav-item>
    <mdb-nav-item :to="{name: 'StaffStudentManagePage'}" icon="users"> 학생관리</mdb-nav-item>
  </mdb-navbar-nav>
</template>
<script>
import { mdbNavbarNav, mdbNavItem, mdbDropdown, mdbDropdownMenu, mdbDropdownToggle, mdbInput, mdbDropdownItem } from 'mdbvue';
import { mapGetters } from 'vuex';
export default {
  name: 'StudentMenu',
  components: { mdbNavbarNav, mdbNavItem, mdbDropdown, mdbDropdownMenu, mdbDropdownToggle, mdbDropdownItem },
  computed: {
    ...mapGetters('auth', ['isStaff', 'isAdmin', 'isManager', 'isTeacher'])
  }
}
</script>
